var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.4244 2.10041V2.04991L17.221 1.83342C16.8759 1.46603 16.3975 1.25 15.8878 1.25C15.3781 1.25 14.8997 1.46603 14.5546 1.83342L14.5544 1.83363L6.84747 10.0442L4.44662 7.47654L4.44543 7.47528C4.10032 7.10788 3.62188 6.89185 3.11221 6.89185C2.60255 6.89185 2.12411 7.10788 1.77899 7.47528L1.77861 7.47569C1.43528 7.84173 1.25 8.32844 1.25 8.82676C1.25 9.32496 1.43519 9.81156 1.77838 10.1776C1.77845 10.1777 1.77853 10.1777 1.77861 10.1778L5.51281 14.1671L5.5128 14.1671L5.5153 14.1698C5.86082 14.5353 6.33843 14.75 6.84693 14.75C7.35543 14.75 7.83305 14.5353 8.17857 14.1698L8.1801 14.1682L17.221 4.54565L17.2214 4.54519C17.5647 4.17915 17.75 3.69243 17.75 3.19412C17.75 2.8052 17.6371 2.42334 17.4244 2.10041Z","fill":"#EBA920","stroke":"#001D3B","strokeWidth":"1.5"}));
}

Tick.defaultProps = {"width":"19","height":"16","viewBox":"0 0 19 16","fill":"none"};

module.exports = Tick;

Tick.default = Tick;
